import { DataType } from "@/types/DataType";

export function useModbusUtils() {
  function getModbusDataLen(_type: DataType | "0" | null) {
    let len = 0;
    if (_type == "float" || _type == "int" || _type == "uint32_t") {
      len = 2;
    }
    if (_type == "uint16_t" || _type == "bool") {
      len = 1;
    }
    return len;
  }

  return { getModbusDataLen };
}
